import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, InputSignal, Signal, ChangeDetectionStrategy } from '@angular/core';
import { AlertComponent } from '@components/atoms/alert/alert.component';
import { CardMode } from '@components/card/card.component';
import {
    CarServicePreferencesFormGroup,
    TransferPreferencesComponent,
} from '@components/molecules/forms/patient-travel-card/transfer-preferences/transfer-preferences.component';
import { MdsDividerComponent, MdsExpansionPanelComponent } from '@medpacesoftwaredevelopment/designsystem';
import { TravelRequest } from '@models/request';
import { Study } from '@models/study';
import { RequestStateService } from '@services/state-management/request-state.service';
import { TravelViewModelService } from '@services/travel-view-model/travel-view-model.service';
import { getAlertContent } from '@utility/utility.travel-request';
import { map } from 'rxjs';
import { CarServiceRequestDetailsFormGroup } from '../../form-groups/detail-form-groups/travel/car-service-request.formgroup';
import { NeedsTravelFormGroup, TravelFormGroup } from '../../form-groups/travel-request-card.formgroup';
import { NeedsTravelRadioGroupComponent } from '../../needs-travel-radio-group/needs-travel-radio-group.component';
import { TransferRequestDetailsEditComponent } from './transfer-request-details-edit/transfer-request-details-edit.component';
import { TransferRequestDetailsViewComponent } from './transfer-request-details-view/transfer-request-details-view.component';

@Component({
    selector: 'medpace-car-service-travel-request-tab',
    imports: [
        CommonModule,
        AlertComponent,
        MdsDividerComponent,
        NeedsTravelRadioGroupComponent,
        TransferRequestDetailsEditComponent,
        TransferRequestDetailsViewComponent,
        TransferPreferencesComponent,
        MdsExpansionPanelComponent,
    ],
    templateUrl: './car-service-travel-request-tab.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './car-service-travel-request-tab.component.scss',
})
export class CarServiceTravelRequestTabComponent {
    private readonly requestStateService = inject(RequestStateService);
    private readonly travelViewModelService = inject(TravelViewModelService);

    public readonly mode: InputSignal<CardMode> = input.required();
    public readonly study: InputSignal<Study> = input.required();
    public readonly formGroup: InputSignal<
        NeedsTravelFormGroup<TravelFormGroup<CarServicePreferencesFormGroup, CarServiceRequestDetailsFormGroup>>
    > = input.required();

    public readonly isCarServiceAvailable: Signal<boolean> = computed(
        () => !!this.study().studyInfo?.studyTravelOptions.find((o) => o.name === 'Car Services')
    );
    public readonly isUpdate = computed(() => !!this.travelViewModelService.travelCardViewModel()?.isUpdate);

    public readonly isCarServiceRequested$ = this.requestStateService.travelRequestStateService
        .getState()
        .pipe(map((travelRequest: TravelRequest) => travelRequest?.carServiceRequired));

    public readonly nonAvailableMessage: string = getAlertContent('car service');
}
